export const FETCH_PROJECTCATEGORY_REQUEST = 'FETCH_PROJECTCATEGORY_REQUEST';
export const FETCH_PROJECTCATEGORY_SUCCESS = 'FETCH_PROJECTCATEGORY_SUCCESS';
export const FETCH_PROJECTCATEGORY_FAILURE = 'FETCH_PROJECTCATEGORY_FAILURE';